import {
  RENT_SAVE,
  RESERVE_SAVE,
  RENT_LIST,
  RENT_STATISTIC,
  RENT_STATISTIC_REJECT_REASON,
  RENT_EXIT_SAVE,
  RENT_EXIT_UPDATE,
  RENT_CONTINUE_SAVE,
  RENT_CONTINUE_UPDATE,
  RENT_CONTINUE_CLEAR,
  RESERVE_LIST,
  RENT_ARCHIVE_LIST,
  RENT_ACCRUAL_LIST,
  INSTRUMENT_LIST,
  INSTRUMENT_SUBTYPES,
  RESERVE_UPDATE,
  RENT_UPDATE,
  ADD_RENTS_TO_LIST,
  ADD_RESERVES_TO_LIST,
  ADD_RENTS_ARCHIVE_TO_LIST,
  INSTRUMENT_CATEGORIES,
  INSTRUMENT_ADD_LIST,
  RENT_CLEAR,
  RENT_EXIT_CLEAR,
  INSTRUMENT_SET_STOCK,
  RENT_TABLE_LIST,
  RENT_TABLE_LIST_HAS_NEXT,
  RENT_ACT_STATUSES,
} from './actionTypes';

const defaultState = {
  rent: null,
  rentContinue: null,
  rentExit: null,
  reserve: null,
  balance: null,
  categories: null,
  subtypes: [],
  hasNext: true,
  reserveList: null,
  reserveInital: null,
  rentInital: null,
  stockID: null,
  rentList: null,
  rentArchiveList: null,
  accrualList: [],
  tableList: null,
  statistic: null,
  statisticRejectReason: null,
  actStatuses: [],
};

export function transferAct(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case RENT_SAVE:
      if (state.rent === null) {
        return { ...state, rentInital: payload, rent: payload };
      }

      return { ...state, rent: payload };

    case RENT_ACT_STATUSES:
      return {
        ...state,
        actStatuses: payload,
      };

    case RENT_CLEAR:
      return {
        ...state,
        rent: null,
      };
    case RENT_TABLE_LIST_HAS_NEXT:
      return { ...state, hasNext: payload };

    case RENT_TABLE_LIST:
      return { ...state, tableList: payload };

    case RENT_EXIT_CLEAR:
      return {
        ...state,
        rentExit: null,
      };

    case RENT_UPDATE:
      return {
        ...state,
        rent: {
          ...state.rent,
          ...payload,
        },
      };

    case RENT_STATISTIC:
      return { ...state, statistic: payload };

    case RENT_STATISTIC_REJECT_REASON:
      return { ...state, statisticRejectReason: payload };

    case INSTRUMENT_SET_STOCK:
      return { ...state, stockID: payload };

    case RENT_EXIT_SAVE:
      if (state.rentExit === null) {
        return { ...state, rentInital: payload, rentExit: payload };
      }
      return { ...state, rentExit: payload };

    case RENT_EXIT_UPDATE:
      return {
        ...state,
        rentExit: {
          ...state.rentExit,
          ...payload,
        },
      };

    case RENT_CONTINUE_SAVE:
      if (state.rentContinue === null) {
        return { ...state, rentInital: payload, rentContinue: payload };
      }

      return { ...state, rentContinue: payload };

    case RENT_CONTINUE_UPDATE:
      return {
        ...state,
        rentContinue: {
          ...state.rentContinue,
          ...payload,
        },
      };

    case RENT_CONTINUE_CLEAR:
      return {
        ...state,
        rentContinue: null,
      };

    case INSTRUMENT_CATEGORIES:
      return { ...state, categories: payload };

    case RENT_ACCRUAL_LIST:
      return { ...state, accrualList: payload };

    case RESERVE_SAVE:
      if (state.reserve === null) {
        return { ...state, reserveInital: payload, reserve: payload };
      }

      return { ...state, reserve: payload };

    case RESERVE_UPDATE:
      return {
        ...state,
        reserve: {
          ...state.reserve,
          ...payload,
        },
      };

    case RENT_LIST:
      return { ...state, rentList: payload };

    case ADD_RESERVES_TO_LIST:
      return { ...state, reserveList: [...state.reserveList, ...payload] };

    case ADD_RENTS_TO_LIST:
      return { ...state, rentList: [...state.rentList, ...payload] };

    case RESERVE_LIST:
      return { ...state, reserveList: payload };

    case RENT_ARCHIVE_LIST:
      return { ...state, rentArchiveList: payload };

    case ADD_RENTS_ARCHIVE_TO_LIST:
      return { ...state, rentArchiveList: [...state.rentArchiveList, ...payload] };
    case INSTRUMENT_LIST:
      return { ...state, balance: payload };

    case INSTRUMENT_SUBTYPES:
      return { ...state, subtypes: payload };

    case INSTRUMENT_ADD_LIST: {
      const balance = state.balance.splice();
      const newBalance = [...balance, ...payload];

      return { ...state, balance: newBalance };
    }

    default:
      return state;
  }
}
